import l10n from 'modapp-l10n';
import ConfirmScreenDialog from 'components/ConfirmScreenDialog';

/**
 * GreetingScreen shows a greeting screen.
 */
class GreetingScreen {

	constructor(app, params) {
		this.app = app;

		this.app.require([
			'screen',
			'auth',
			'api',
			'realmInfo',
		], this._init.bind(this));
	}

	_init(module) {
		this.module = Object.assign({ self: this }, module);
		this.disposed = false;
		this._showRealm();
	}

	async _showRealm() {
		try {
			const resources = await this.module.realmInfo.getResources();
			if (this.disposed) {
				this.module.realmInfo.releaseResources();
				return;
			}
			this.resources = resources;
			this.module.screen.setComponent(this.module.realmInfo.newRealmInfo(this.resources, {
				withSignIn: true,
				withFooter: true,
			}));
		} catch (err) {
			if (this.resources) {
				this.module.realmInfo.releaseResources();
			}
			console.error(err);
			let realmName = this.app.props.realm?.name || l10n.t('greetingScreen.thisRealm', "this realm");
			// Fallback dialog
			this.module.screen.setComponent(new ConfirmScreenDialog({
				title: l10n.l('greetingScreen.welcome', "Welcome to {realmName}", { realmName }),
				confirm: l10n.l('greetingScreen.gotToLogin', "Go to login"),
				body: l10n.l('greetingScreen.welcomeBody', "You are currently not logged in."),
				onConfirm: () => this.module.auth.redirectToLogin(true),
			}));
		}
	}

	dispose() {
		if (this.resources) {
			this.module.realmInfo.releaseResources();
			this.resources = null;
		}
		this.disposed = true;
	}
}

export default GreetingScreen;
